import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { Reels } from "@lib/titan2-slingo/dist/game/view/abstract/display/Reels";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { GameEvent } from "../../../controller/event/GameEvent";
/**
 * GameReels.ts
 */
export class GameReels extends Reels {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.FEATURE_START, this.hide);
        this.registerGame(GameEvent.FEATURE_END, this.show);
        this.registerGame(GameEvent.TICKET_TRANSITION_OUT_COMPLETE, this.handleTicketTransitionOut);
        this.registerGame(GameEvent.TICKET_TRANSITION_IN, this.handleTicketTransitionIn);
        this.registerGame(SlingoEvent.DAB_SUCCESS, this.handleDabSuccess);
        this.registerGame(GameEvent.COIN_WIN_START, this.handleCoinWin);
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleReelsComplete);
        this.registerGame(GameReelsEvents.TRANSITION_TO_FEATURE_FADE_OUT, this.handleTransitionToFeatureFadeOut);
        this.registerGame(GameReelsEvents.TRANSITION_FROM_FEATURE_FADE_IN, this.handleTransitionFromFeatureFadeIn);
    }
    handleTransitionToFeatureFadeOut() {
        gsap.to(this, { alpha: 0 });
    }
    handleTransitionFromFeatureFadeIn() {
        this.visible = true;
        this.alpha = 0;
        gsap.to(this, { alpha: 1 });
    }
    handleRecovery() {
        super.handleRecovery();
        this.handleReelsComplete();
        this.handleReelsAward();
    }
    handleTicketTransitionOut() {
        this.destroyReels();
    }
    handleTicketTransitionIn() {
        this.createReels();
        this.resetReels();
    }
    handleFreeSpinAward() {
        const next = this.freeSpinIndices.shift();
        if (typeof next === "number" && this.reels[next]) {
            this.reels[next].collectFreeSpin();
        }
    }
    handleCoinWin() {
        this.reels[2].collectCoinWin();
    }
    handleDabSuccess() {
        const autoDabbedIndex = this.model.getDabData().getAutoDabIndex() - 1;
        if (autoDabbedIndex >= 0 && autoDabbedIndex < this.model.getDabData().getAutoDabCells().length) {
            const autoDab = this.model.getDabData().getAutoDabCells()[autoDabbedIndex];
            const numberToDab = autoDab.getNumber();
            const numberInReel = parseInt(this.model.getReelDisplayData().getDisplaySymbols()[autoDab.getColumn()].getId());
            const isNumberMatch = numberToDab === numberInReel;
            if (isNumberMatch) {
                this.reels[autoDab.getColumn()].collectNumber();
            }
        }
        if (autoDabbedIndex === this.model.getDabData().getAutoDabCells().length - 1) {
            // HACK increment the index past the bounds, to avoid triggering the animations again,
            // as this method gets called when wilds and super-wilds get selected _after_ the number matches are supposed to have happened. 
            //@ts-ignore
            this.model.getDabData().autoDabIndex++;
        }
    }
    handleReelsComplete() {
        this.reels.forEach((reel, index) => {
            const isJokerReel = this.model.getReelDisplayData().getDisplaySymbols()[index].isJoker();
            const isSuperJokerReel = this.model.getReelDisplayData().getDisplaySymbols()[index].isSuperJoker();
            if (isJokerReel) {
                reel.animateJoker();
            }
            else if (isSuperJokerReel) {
                reel.animateSuperJoker();
            }
        });
    }
}
export class GameReelsEvents {
}
GameReelsEvents.TRANSITION_TO_FEATURE_FADE_OUT = new EventObject("GameReelsEvents.TRANSITION_TO_FEATURE_FADE_OUT");
GameReelsEvents.TRANSITION_FROM_FEATURE_FADE_IN = new EventObject("GameReelsEvents.TRANSITION_FROM_FEATURE_FADE_IN");
//# sourceMappingURL=GameReels.js.map